import moment from 'moment-timezone';
import React from 'react';

import { getBrandSafetyTracker, IBrandSafetyTracker } from '~/src/dash/api/brand-safety-tracker';
import { IHttpResponse } from '~/src/dash/api/rest';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { BrandSafetyTrackerEdit } from '~/src/dash/views/brand-safety-tracker-edit';

interface IProps extends IWithStylesProps, IReduxActionProps, ISessionStateProps, IHistoryProps {}

class IState {
  tracker: IBrandSafetyTracker; // tracker to edit
  loaded: boolean; // is tracker loaded
  error: string; // if not empty, display an error in the snackbar
}

export const BrandSafetyTrackerEditView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
  },
  class extends React.Component<IProps, IState> {
    state = {
      tracker: {} as IBrandSafetyTracker,
      loaded: false,
      error: '',
    };

    componentDidMount() {
      // get id of tracker to edit
      const loc = parseLocation(this.props.location.pathname);
      const trackerID = Number(loc.brandSafetyTracker);
      // try to get the tracker from session
      this.getTrackerFromAPI(trackerID);
    }

    // gets the tracker from the API
    getTrackerFromAPI = (trackerID: number): void => {
      getBrandSafetyTracker(trackerID.toString(), this.props.session.publisher.ID)
        .then((val: IHttpResponse<IBrandSafetyTracker>) => {
          const tracker = val.parsedBody as IBrandSafetyTracker;
          if (!tracker.SiteIDS) {
            tracker.SiteIDS = [];
          }
          if (!tracker.ChannelGroupIDS) {
            tracker.ChannelGroupIDS = [];
          }
          if (!tracker.BidderIDS) {
            tracker.BidderIDS = [];
          }
          if (!tracker.BidderGroupIDS) {
            tracker.BidderGroupIDS = [];
          }
          this.setState({
            tracker,
            loaded: true,
            // check if the tracker is new
            error:
              moment().tz('UTC').diff(moment(tracker.CreatedAt), 'seconds') < 2
                ? 'New brand safety tracker successfully created'
                : '',
          });
        })
        .catch(() => {
          this.setState({
            loaded: false,
          });
        });
    };

    // display the edit form for this rule
    render() {
      return (
        <div>
          {this.state.loaded && (
            <BrandSafetyTrackerEdit tracker={this.state.tracker} error={this.state.error} />
          )}
        </div>
      );
    }
  },
);
